export default {
    'common.delete': 'Fshi',
    'common.edit': 'Edito',
    'common.yes': 'Po',
    'common.no': 'Jo',
    'common.reset_sale': 'Rifillo shitjen',
    'common.previewPolicy': 'Shiko PDF e polices',
    'common.confirmDelete': 'Konfirmo fshirjen?',
    'common.general': 'Informacione Gjenerale',
    'common.cancel': 'Anullo',
    'common.save': 'Ruaj',
    'common.add': 'Shto',
    'common.plate': 'Targa',
    'common.continueManually': 'Vazhdo manualisht',
    'common.continue': 'Vazhdo',
    'common.back': 'Kthehu',
    'common.buy': 'Bli',
    'common.sell': 'Shitet',
    'common.clear': 'Pastro',
    'common.filter': 'Filtër',
    'common.actions': 'Veprimet',
    'common.add.permission': 'Shto lejet',
    'common.add.role': 'Shto role',
    'common.search.here': 'Kërko këtu...',
    'common.loading': 'Po ngarkohet...',
    'common.seeLess': 'Shiko më pak',
    'common.seeMore': 'Shiko më shumë',
    'common.coverages': 'Mbulime',
    'common.durations': 'Kohëzgjatja',
    'common.stocks': 'Aksione',
    'common.templates': 'Paketë',
    'common.basePolicy.addPolicy': 'Shto Policë {firstArg}',
    'common.Waiting for the server': 'Duke pritur pergjigje nga serveri...',
    'common.premiumStructure': 'Struktura e primit',
    'common.Participating parties': 'Palët pjesëmarrëse',
    'common.Insured Items': 'Objektet e siguruara',
    'common.Policy PDF': 'Kopje e polices',
    'common.Comments': 'Komentet',
    'common.assets': 'Asetet',
    'common.Policy Dates': 'Datat e polices',
    'common.Other Informations': 'Informacione të tjera',
    'common.Clients': 'Klientë',
    'common.Beneficiaries': 'Përfituesit',
    'common.Co-Insurers': 'Bashkësiguruesit',
    'common.Insurers': 'Siguruesit',
    'common.Insured': 'Te siguruarit',
    'common.EditDescription': 'Edito Pershkrimin',
    'common.AddDescription': 'Shto Pershkrim',
    'common.InvoiceRecipients': 'Faturuari',
    'common.PolicyHolder': 'Mbajtësit e policës',
    'common.emptyPolicy': 'Kjo policë nuk ka asnjë objekt/mbulim të siguruar!',
    'common.flat': 'E sheshtë',
    'common.total': 'Total',
    'common.noViews': 'Pa pamje',
    'common.searchAddress': 'Kërko adresën',
    'common.selectRecord': 'Zgjidh regjistrimin',
    'common.info': 'Informacione Personale',
    'common.Policies': 'Policat',
    'common.Documents': 'Dokumentet',
    'common.Customer Policies': 'Policat e Klientit',
    'common.Premiums': 'Primet',
    'common.Claims': 'Pretendimet',
    'common.quickReports': 'Raporte të shpejta',
    'common.ratio': 'Raporti Premium/Kërkesë',
    'common.unpaidObligations': 'Tabela e detyrimeve të papaguara',
    'common.comments': 'Komente',
    'common.Address': 'Adresa & Kontakt',
    'common.enable': 'Aktivizo:',
    'common.Fixed value': 'Vlera fikse',
    'common.Upload documents': 'Ngarko dokumente',
    'common.upload': 'Terhiq skedarin ose kliko në këtë zonë për te ngarkuar',
    'common.file': 'skedar',
    'common.uploaded': 'i ngarkuar',
    'common.removed': 'i hequr',
    'common.successfully': 'me sukses',
    'common.updated': 'i përditësuar',
    'common.created': 'krijuar',
    'common.searchVin': 'Kërko shasinë në sistem me targë',
    'common.SearchVin': 'Kërko shasinë',
    'common.enterPlate': 'Vendosni targën e mjetit...',
    'common.vin': 'Shasia',
    'common.enterVin': 'Ju lutemi vendosni shasinë!',
    'common.enterVinPlease': 'Vendosni shasinë e automjetit...',
    'common.Classification Tpl': 'Klasifikimi Tpl',
    'common.City': 'Qyteti',
    'common.Category': 'Kategoria',
    'common.Vin': 'Shasia',
    'common.Make': 'Marka',
    'common.Model': 'Model',
    'common.Engine': 'Motor',
    'common.Volume': 'Vëllimi',
    'common.Fuel': 'Karburant',
    'common.Capacity': 'Kapaciteti',
    'common.Color': 'Ngjyra',
    'common.Seats': 'Sedilje',
    'common.Year': 'Viti',
    'common.fillInVehicle': 'Plotësoni të dhënat e automjetit',
    'common.Classification': 'Klasifikimi',
    'common.Type': 'Lloji',
    'common.writeComment': 'Shkruani komentin...',
    'common.finalizeSale': 'Finalizo shitjen',
    'common.Add Comment': 'Shto koment',
    'common.Add': 'Shto',
    'common.policyParticipants': 'Pjesëmarrësit e polices',
    'common.participants01': 'Fatura i është bërë liderit',
    'common.participants02': 'Fatura të ndahet sipas pjesëmarrjes në përqindje',
    'common.participants03': 'Fatura i behet 100% klientit',
    'common.participants04': 'Fatura i bëhet klientit sipas përqindjes',
    'common.participants05': 'Fatura i bëhet liderit sipas përqindjes',
    'common.warning': 'Paralajmërim',
    'common.Renewals': 'Rinovimet',
    'common.years': 'vite',
    'common.months': 'muaj',
    'common.days': 'ditë',
    'common.Custom': 'Me porosi',
    'common.Renewable': 'E rinovueshme',
    'common.Renewable Frequency': 'Frekuenca e Rinovueshme',
    'common.Month': 'Muaj',
    'common.Confirm': 'Konfirmo',
    'common.blocker': 'A jeni i sigurt që dëshironi të largoheni nga kjo faqe?',
    'common.afterBlocker': 'Ndryshimet nuk do të ruhen!',
    'common.LogOut': 'Dil',
    'common.changePassword': ' Ndrysho fjalëkalimin',
    'common.areUsure': 'A jeni i/e sigurt që dëshironi të finalizoni këtë shitje?',
    'common.clickConfirm': 'Kliko butonin më poshtë nëse dëshiron të shohësh Policen PDF',
    'common.Period': 'Periudha',
    'common.Today': 'Sot',
    'common.This week': 'Këtë javë ',
    'common.This month': 'Këtë muaj',
    'common.Last month': 'Muajin e kaluar',
    'common.This year': 'Kete vit',
    'common.Last year': 'Vitin e kaluar',
    'common.Coverage': 'Mbulimi',
    'common.Duration': 'Kohëzgjatja',
    'common.Stock': 'Aksione',
    'common.Template': 'Paketë',
    'common.Template Items': 'Mbulim Pakete',
    'common.Premium': 'Primi',
    'common.Set Percentage': 'Vendosni përqindjen',
    'common.Driver': 'Shofer',
    'common.Owner': 'Pronari',
    'common.REMOVE': 'FSHI',
    'common.EDIT': 'EDITO',
    'common.Add Driver': 'Shto shofer',
    'common.Update Driver': 'Përditëso drejtuesin',
    'common.Same as owner': 'Shoferi është i njëjtë me pronarin',
    'common.Same as policyHolder': 'Shoferi është i njëjtë me mbajtësin e policës',
    'common.Write the Serial': 'Shkruaj serialin',
    'common.Serials in Condition': 'Seriali ne gjendje',
    'common.reserveSerial': 'Rezervo një serial',
    'common.serialRequiredToReserve': "Nuk ka serial për t'u rezervuar",
    'common.select': 'Zgjidh',
    'common.serialReserved': 'Seriali {serial} u rezervua me sukses',
    'common.useReservedSerial': 'Përdor një serial të rezervuar',
    'common.selectReservedSerial': 'Zgjidh një serial të rezervuar',
    'common.noReservedSerials': 'Ky produkt nuk ka ende seriale të rezervuara',
    'common.Premium Structure': 'Struktura e Primit',
    'common.Policy Documents': 'Dokumentet e Polices',
    'common.TPLpolicy': 'Polica TPL',
    'common.TPLcompany': 'TPL Company',
    'common.calculatedPremium': 'Primi i llogaritur është',
    'common.changePremium': 'Nëse doni të ndryshoni primin',
    'common.place': 'Vendos',
    'common.coveragesNull': 'Ky produkt nuk ka mbulime. Kontrollo konfigurimin e produktit!',
    'common.Selected': 'Zgjedhur',
    'common.sumInsured': 'Shuma e siguruar',
    'common.driversAreSame': 'Shoferët janë të njëjtë me TPL',
    'Fixed value': 'Vlera fikse',
    damage: 'e çdo dëmi',
    '% damage': '% e çdo dëmi',
    'Min % damage': 'Min % e çdo dëmi',
    'Max % damage': 'Max % e çdo dëmi',
    'of the sum insured': 'e shumës së siguruar',
    '% of the sum insured': '% e shumës së siguruar',
    'Min % of the sum insured': 'Min % e shumës së siguruar',
    'Max % of the sum insured': 'Max % e shumës së siguruar',
    'common.resetFilters': 'Pastro filtrat',
    'common.resetColumns': 'Pastro kolonat',
    'common.close': 'Mbyll',
    'endingPolicies.period': 'Policat që skadojnë nga {firstArg} deri më {secondArg}',
    'endingPolicies.total': 'Totali i policave: {firstArg}',
    'endingPolicies.totalLabel': 'Totali',
    'endingPolicies.view': 'Shiko policat',
    'common.No internet connection!': 'Nuk ka lidhje interneti!',
    'common.Reload page': 'Ringarko faqen',
    'common.autosos': 'AutoSOS - Plotësoni fushat më poshtë',
    'common.autosos.question': 'A doni të hiqni mbulimin AutoSOS?',
    'common.Add New': 'Shto nje te ri',
    'common.Add New Row': 'Shto nje rresht te ri',
    'common.add New Payment': 'Shto pagese te re',
    'common.User Info': 'Informacioni i përdoruesit',
    'common.Create User': 'Krijo përdorues',
    'common.create': 'Krijo',
    'common.saveVehicleData': 'Ruaj të dhënat e automjetit',
    'common.Check Balance': 'Kontrollo balancën',
    'common.Error occurred:': 'Ndodhi një gabim:',
    'common.Something went wrong. Please contact IT department!': 'Diçka shkoi keq. Ju lutemi kontaktoni departamentin e IT!',
    'common.Policy Holder': 'Mbajtës i policës',
    'common.Add Client': 'Shto klient',
    'common.Client Card': 'Karta e klientit',
    'common.Client Info': 'Informacioni i klientit',
    'common.Insured People': 'Njerëz të siguruar',
    'common.Settings': 'Cilësimet',
    'common.insurerTeller': 'Polica po shitet per',
    'common.amfTeller': 'Të dhënat e mjetit kanë ardhur nga AMF dhe nuk mund të ndryshohen.',
    'common.validate': 'Valido',
    'common.noticeDateInfo': "Për të ruajtur datën shtypni 'Enter'",
    'common.warning.notice': 'Ndryshime të reja kanë ndodhur në sistem. Ju lutemi ringarkoni faqen!',
    'common.Clients Terms': 'Kushtet e klientit',
    'common.fillInContactType': 'Plotësoni llojin e kontaktit',
    'common.carefulWarning': 'Kujdes! Ju nuk po shisni me:',
    'common.insurerThatIsSelling': 'Ju jeni duke shitur për:',
    'common.youSure': 'Jeni i sigurt që dëshironi të vazhdoni?',
    'common.refreshLogo': 'Rifresko logon',
    'common.showMore': 'Shiko më shumë',
    'common.showLess': 'Shiko më pak',
    'common.vehicleInfo': 'Informacione mbi automjetin',
    'common.listOfObjects': 'Lista e objekteve',
    'common.addObjects': 'Shto objekt',
    'common.fillObjects': 'Plotëso objektin',
    'common.nr': 'Nr',
    'common.fillCityBefore': 'Plotëso qytetin si fillim!',
    'common.Export as CSV': 'Exporto si CSV',
    'common.Export as Excel': 'Exporto si Excel',
    'common.premium': 'Primi',
    'common.calculated': 'I Kalkulueshëm',
    'common.serialClickHint': 'Kliko 2 here mbi serialin qe do të selektosh',
    'common.SerialClickHint': 'Kliko mbi serialin qe do të selektosh',
    'common.companyLogo': 'Kompani Logo',
    'common.View the PDF': 'Printo Policen',
    'common.ownerBlocked': 'Pronari eshte i kyçur dhe nuk mund te ndryshohet',
    'common.emailSenderInfo': 'Per ta derguar policen ne e-mail te klientit, ju lutem plotesoni fushen me poshte. Nese jo, mos e plotesoni.',
    'common.downloadExcel': 'Zgjidhni intervalin e datave kur jane leshuar policat dhe klikoni "Konfirmo" për ti eksportuar!',
    'common.noAccess': 'Nuk keni akses',
    'common.changes': 'Ndryshimet',
    'Select Product': 'Zgjidhni Produktin',
    'Select Account': 'Zgjidhni Llogarinë',
    modifyPolicy: 'Modifiko Policën',
    uploaded: 'ngarkuar',
    removed: 'hequr',
    successfully: 'me sukses',
    'common.Drivers': 'Shoferet',
    'common.disabledButtonTooltip': 'Kerkimi me targe shasi eshte inaktiv sepse po kryhet rinovim police',
    'buttonDisabled.renewal': 'Butoni eshte i çaktivizuar sepse funksionaliteti per rinovim nuk ka perfunduar!',
    'buttonDisabled.duplication': 'Butoni eshte i çaktivizuar sepse funksionaliteti per duplikim nuk ka perfunduar!',
    'buttonDisabled.premiumReturned': 'Butoni është i çaktivizuar sepse funksionaliteti per urdher anullim nuk funksionon per kete lloj police!',
    'buttonDisabled.cancel': 'Butoni është i çaktivizuar sepse polica është tashmë e anulluar!',
    'buttonDisabled.cancelPermission': 'Ju nuk keni të drejtë si agjent te anulloni këtë policë!',
    'Modification of the policy': 'Modifikimi i polices',
    'Policy holders': 'Police mbajtesit',
    Beneficiary: 'Perfituesi',
    Insurers: 'Siguruesit',
    Insured: 'Te siguruarit',
    'Select All Agencies': 'Selekto te gjitha agjencite',
    'Deselect All Agencies': 'Hiq selektimin',
    'Less than': 'Më pak se',
    'Greater than': 'Më e madhe se',
    'Less than or equal': 'Më pak se ose e barabartë',
    'Greater than or equal': 'Më e madhe se ose e barabartë',
    'In range': 'Ndermjet',
    from: 'nga',
    to: 'deri',
    Equals: 'E barabartë',
    'Not equal': 'Jo i barabartë',
    Blank: 'Bosh',
    'Not blank': 'Jo Bosh',
    'Choose One': 'Zgjidh nje',
    Contains: 'Përmban',
    'Not contains': 'Nuk përmban',
    'Starts with': 'Fillon me',
    'Ends with': 'Mbaron me',
    AND: 'DHE',
    OR: 'OSE',
    Apply: 'Apliko',
    Reset: 'Rivendos',
    ResetData: 'Rivendos të dhënat',
    Clear: 'Pastro',
    Cancel: 'Anulo',
    Filters: 'Filtrat',
    Columns: 'Kolonat',
    Limits: 'Limite',
    Sublimits: 'Sherbimet',
    SingleYear: 'Vit',
    'Motor Policies': 'Policat Motorike',
    'Health Policies': 'Policat e Shendetit',
    Canceled: 'Anulluar',
    Returned: 'Urdhër anullim',
    Issued: 'Shitur',
    Drafted: 'Ne pritje',
    NoStatus: 'Nuk ka status',
    Cancelled: 'Anulluar',
    Duplicated: 'Dublikuar',
    Blocked: 'Bllokuar',
    Draft: 'Draft',
    Modified: 'Sistemim',
    'common.noticeForExport': 'Ju mund te eksportoni policat ne CSV/EXCEL tek butonat ne te djathte',
    'common.NoticeForExport': 'Ju mund te eksportoni police ne CSV/EXCEL duke perdorur butonat me poshte.',
    'common.chooseRenewalsFirst': 'Zgjidhni vitet e rinovimeve për të llogaritur daten e perfundimit!',
    'common.writeHere': 'Ju mund të shkruani përshkrimin e policës këtu...',
    'common.RolesNotify': 'Shtoni akseset në këtë rol. Përdoruesit që kanë këtë rol do të marrin të gjitha akseset më poshtë.',
    'common.Assign Permission': 'Percakto akseset',
    'Search permission': 'Kërko aksesin',
    'common.Remove permission?': 'A jeni i sigurtë që doni të fshini këtë akses?',
    'common.areUSure': 'A jeni i sigurtë per këte veprim?',
    'common.updatePassword': 'Përditëso fjalëkalimin',
    searchProduct: 'Kerko produktin',
    'Insured object description': 'Përshkrimi i objektit të siguruar',
    'Installments & Renewals': 'Këste & Rinovime',
    'Total installments': 'Totali i kësteve',
    'Do you want to be the same as the beneficiary?': 'Deshiron te jete i njejte me perfituesin?',
    'Do you want to be the same as the policy holder?': 'Deshiron te jete i njejte me police mbajtesin?',
    'Motor Product': 'Produkti motorik',
    'You want to select the address on the map?': 'Deshironi te zgjidhni adresen ne harte?',
    'Companion Policy': 'Polica Shoqeruese',
    'Change bank': 'Përditëso bankën',
    'Add bank': 'Shto bankën',
    'Delete bank': 'Fshi bankën',
    'common.bankInfo': 'Nëse opsioni i përzgjedhur është "bankë", do tju jepet mundësia të regjistroni bankën!',
    'common.noBankBranches': 'Kujdes: Kjo bankë nuk ka asnjë degë!',
    'Update Notary': 'Përditëso Noterin',
    'Add Notary': 'Shto Noterin',
    'Update Insurance Agent': 'Përditëso agjentin e sigurimit',
    'Add Insurance Agent': 'Shto agjentin e sigurimit',
    'common.undefined': 'E pa përcaktuar',
    'common.Bank': 'Bankë',
    'common.Agent': 'Agjent',
    'common.Client': 'Klient',
    'common.Invoice': 'Faturë',
    'common.valueLCY': 'Vlera ALL',
    Add: 'Shto',
    Update: 'Përditëso',
    'Select bank branch': 'Zgjidhni degën e bankës',
    Configurations: 'Konfigurimet',
    'All Configurations': 'Të gjitha konfigurimet',
    'Product Configurations': 'Konfigurimet e produktit',
    'Agency Configurations': 'Konfigurimet e agjencisë',
    'Product Template Configurations': 'Konfigurimet e paketave të produktit',
    'Add Bank Branch': 'Shto degë banke',
    'Bank Branch': 'Dega e bankës',
    noBankBranches: 'Kjo bankë nuk ka asnjë degë banke',
    'Remove according to the authorization': 'Hiqni "Sipas Autorizimit"',
    'Add according to the authorization': 'Shtoni "Sipas Autorizimit"',
    'Object Value': 'Vlera e mjetit',
    'Is Approved': 'Aprovuar',
    'Add insured person': 'Shto person te siguruar',
    'List of Persons': 'Lista e personave',
    'Assign Role': 'Vendos rolet',
    'Assign Permission': 'Vendos akseset',
    Assignment: 'Detyrë',
    Permission: 'Akses',
    'Empty Mass': 'Masa bosh',
    'Shto broker': 'Shto broker',
    Përdoruesit: 'Përdoruesit',
    'Fill in the fields': 'Plotesoni fushat',
    'Select the invoice': 'Selekto faturen',
    'Fill in the account type and its value!': 'Ploteso llojin e llogarise dhe vleren e tij!',
    'For the applied filters:': 'Per filtrat e aplikuar:',
    'Please fill in the account first to display the list of balances!': 'Plotesoni me pare llogarine per te afishuar listen e balancave!',
    Export: 'Exporto',
    Print: 'Printo',
    From: 'Nga',
    To: 'Deri në',
    'Cumulative Balance': 'Gjendje progresive',
    Edito: 'Edito',
    'Accidental Damages Duration': 'Kohëzgjatja e dëmeve aksidentale',
    renew: 'Rinovo',
    edit: 'Edito',
    cancellationOrder: 'Urdher anullim',
    arrangement: 'Sistemim',
    duplicate: 'Duplikate',
    annex: 'Shtojca',
    printIndividual: 'Printo Individual',
    printCollective: 'Printo Kolektiv',
    reprint: 'Riprinto',
    cancel: 'Anullo',
    deletePremiumDifferenceAdjustment: 'Fshi ndryshimin',
    selectProductsThatAgentCanAdjustPremium: 'Selekto produktet te cilat agjenti mund të axhustoje primin',
    selectpaymentMethodForCascoProduct: 'Selekto llojin e pagesës për produktin Kasko',
    activateCustomPackages: 'Aktivizo Paketat e personalizuara',
    activateCustomPackage: 'Aktivizo Paketën e personalizuar',
    searchProductByName: 'Kërko produktin me emër...',
    searchPaymentType: 'Kërko llojin e pageses...',
    participantsInheritance: 'Trashëgimia e participantëve',
};
